descriptionHandler = {
    $panelDescription = $('.panel-description'),
    $window = $(window),
    isOnLoad = false,
    lastWindowWidth = $window.width(),
    resizeTimeout = null,

    animateData = function(isReload = false) {
        this.$panelDescription.each(function(){
            var $titleAnimation = $(this).find(".title-animation");
            var $descContainer = $(this).find('.desc-container');
            var $sloganText = $(this).find('.slogan-text');

            if ($titleAnimation) {
                animateHandler.animateScroll($titleAnimation, 2, isReload);
            }

            if ($descContainer) {
                var $descAnimateTitle = $descContainer.find('h1,h2');
                var $descAnimateText  = $descContainer.find('p');

                if (!isReload) {

                    $descAnimateTitle.addClass('desc-animate-scroll color-pink');
                    $descAnimateText.addClass('desc-animate-scroll');

                    $descAnimateText.each(function(){
                        var uniqID = animateHandler.uniqId();
                        $(this).attr('data-id', uniqID);
                        $(this).data('id', uniqID);
                    })

                }

                animateHandler.animateScroll($descAnimateTitle, 2, isReload);
                animateHandler.animateScroll($descAnimateText, 2, isReload);
            }

            if ($sloganText) {
                animateHandler.animateScroll($sloganText, 2, isReload);
            }
        });
    },

    init = function(){
        var self = this;
        this.isOnLoad = true;

        gsap.registerPlugin(SplitText, ScrollTrigger);

        this.animateData();

        this.$window.resize(function(){
            clearTimeout(self.resizeTimeout);
            self.resizeTimeout = setTimeout(function() {
                if (self.isOnLoad) {
                    self.isOnLoad = false;   
                } else {
                    var windowWidth = $window.width();
                    if (windowWidth != self.lastWindowWidth) {
                        self.animateData(true);
                        self.lastWindowWidth = windowWidth;
                    }
                }   
            }, 25);
        });

    }     
}